module.exports = "https://bicocca-network.servercdn.it/static/fonts/FuturaPT-Heavy.woff2?022a03761099f1b28344feb734292bd9";